import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PortfolioService} from '../portfolio.service';
import {UserService} from '../../../shared-components/user/user.service';
import {TylFormFieldComponent} from '../../../shared-components/controls/tyl-form-field/tyl-form-field.component';

@Component({
  selector: 'app-edit-portfolio-modal',
  templateUrl: './edit-portfolio-modal.component.html',
  styleUrls: ['./edit-portfolio-modal.component.css']
})
export class EditPortfolioModalComponent implements OnInit {
  @ViewChild('fileCategoryInput', { static: true }) categoryInput: TylFormFieldComponent;
  document: any;
  editDocumentForm: FormGroup;
  category: number;
  description: string;
  portfolioCategories: any[];
  fileCategoryErrorMessage = 'Required Field';
  fileDescriptionErrorMessage = 'Required Field';
  constructor(private dialogRef: MatDialogRef<EditPortfolioModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private portfolioService: PortfolioService, private userService: UserService) { }

  ngOnInit() {
    this.document = this.data;
    this.editDocumentForm = new FormGroup({
      'fileCategory': new FormControl(null, [
        Validators.required,
      ]),
      'fileDescription': new FormControl(null, [
        Validators.required,
      ])
    });
    this.onChanges();
    this.portfolioService.getPortfolioCategories(this.userService.currentUser.Id).subscribe(res => {
      this.portfolioCategories = res;
      const category = this.portfolioCategories.findIndex(cat => cat.StuPortCategoryName == this.document.Category)
      this.fileCategory.setValue(this.portfolioCategories[category].StuPortCategory_ID);
      this.fileDescription.setValue(this.document.Description);
    });
  }

  closeClick() {
    this.dialogRef.close();
  }

  saveClick() {
    if (this.checkInputs()) {
      this.document.AddedBy = this.userService.currentUser.MemberId;
      this.document.Category = this.portfolioCategories.find(cate => cate.StuPortCategory_ID == this.fileCategory.value).StuPortCategoryName;
      this.document.Description = this.description;
      this.document.CategoryID = this.fileCategory.value;
      // save to the database
      this.portfolioService.editStudentPortfolio(this.document).subscribe(res => {
        if (res.ok) {
          // Close the dialog
          this.dialogRef.close('Success');
        }
      });
    }
  }

  checkInputs(): boolean {
    let isValid = true;
    if (this.fileCategory.invalid) {
      this.fileCategory.markAsTouched();
      this.fileCategory.markAsDirty();
      isValid = false;
    }
    if (this.fileDescription.invalid) {
      this.fileDescription.markAsTouched();
      this.fileDescription.markAsDirty();
      isValid = false;
    }
    return isValid;
  }

  get fileCategory() {
    return this.editDocumentForm.get('fileCategory');
  }

  get fileDescription() {
    return this.editDocumentForm.get('fileDescription');
  }

  onChanges(): void {
    this.editDocumentForm.valueChanges.subscribe(val => {
      this.category = val['fileCategory'];
      this.description = val['fileDescription'];
      // check new Category
      if (this.editDocumentForm.controls.fileCategory.invalid) {
        if (this.editDocumentForm.controls.fileCategory.errors.hasOwnProperty('required')) {
          this.fileCategoryErrorMessage = 'Category is required';
        }
      }
      // Check Description
      if (this.editDocumentForm.controls.fileDescription.invalid) {
        if (this.editDocumentForm.controls.fileDescription.errors.hasOwnProperty('required')) {
          this.fileDescriptionErrorMessage = 'Description is required';
        }
      }
    });
  }
}
